import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { faqItems } from '../../i18n/translations';
import './FAQ.css';

export default function FAQSection({ limit }) {
  const { t, lang } = useLanguage();
  const [openIndex, setOpenIndex] = useState(null);
  const items = limit ? faqItems[lang].slice(0, limit) : faqItems[lang];

  return (
    <section className="section faq-section">
      <div className="container">
        <div className="section-header">
          <h2>{t.faq.title}</h2>
        </div>
        <div className="faq-list">
          {items.map((item, i) => (
            <div
              key={i}
              className={`faq-item ${openIndex === i ? 'open' : ''}`}
            >
              <button
                className="faq-question"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                {item.q}
                <ChevronDown size={20} />
              </button>
              <div className="faq-answer">
                <p>{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
